/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();

      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();

      this.updateAvailability();
      this.updateCustomSelectSwatches();

      this.addEventListener(
        'change',
        this.handleVariantChange.bind(this)
      );
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
   handleVariantChange(evt) {
  this.selectOriginFallback(evt);

  const selectedOptions = this.getSelectedOptions();
  this.variant = this.data.product.variants.find((variant) =>
    variant.options.every((value, index) => value === selectedOptions[index])
  ) || null;

  if (this.variant) {
    this.updateMedia();
    this.updateUrl(evt);
    this.updateVariantInput();
  }

  this.updateAddToCartButton();
  this.updateAvailability();
  this.updatePrice();
  this.updateBackorderText();
  this.updatePickupAvailability();
  this.updateSku();

  VariantPicker.updateLabelText(evt);
  this.updateCustomSelectSwatches();

  this.dispatchEvent(new CustomEvent('on:variant:change', {
    bubbles: true,
    detail: {
      form: this.productForm,
      variant: this.variant,
      product: this.data.product
    }
  }));
}

selectOriginFallback(evt) {
  if (!evt?.target?.closest('.bijoux-origin-selector')) return;

  const selectors = Array.from(this.optionSelectors).slice(
    0,
    this.data.product.options.length
  );

  const originSelector = this.querySelector('.bijoux-origin-selector');
  const centerSelector = this.querySelector('.bijoux-center-selector');
  const metalSelector = this.querySelector('.bijoux-metal-selector');

  if (!originSelector || !centerSelector) return;

  const originIndex = selectors.indexOf(originSelector);
  const centerIndex = selectors.indexOf(centerSelector);
  const metalIndex = selectors.indexOf(metalSelector);

  if (originIndex === -1 || centerIndex === -1) return;

  const normalize = (value) =>
    String(value || '').replace(/\s+/g, ' ').trim();

  const selectedOptions = this
    .getSelectedOptions()
    .slice(0, selectors.length);

  const exactVariant = this.data.product.variants.find((variant) =>
    variant.available &&
    variant.options.every(
      (value, index) =>
        normalize(value) === normalize(selectedOptions[index])
    )
  );

  if (exactVariant) return;

  const selectedOrigin = normalize(selectedOptions[originIndex]);
  const selectedMetal = metalIndex !== -1
    ? normalize(selectedOptions[metalIndex])
    : '';

  const validCenter = (variant) => {
    const value = normalize(variant.options[centerIndex]);
    return value && value !== '0';
  };

  let fallbackVariant = this.data.product.variants.find((variant) =>
    variant.available &&
    validCenter(variant) &&
    normalize(variant.options[originIndex]) === selectedOrigin &&
    (
      metalIndex === -1 ||
      normalize(variant.options[metalIndex]) === selectedMetal
    )
  );

  if (!fallbackVariant) {
    fallbackVariant = this.data.product.variants.find((variant) =>
      variant.available &&
      validCenter(variant) &&
      normalize(variant.options[originIndex]) === selectedOrigin
    );
  }

  if (!fallbackVariant) return;

  selectors.forEach((selector, index) => {
    const value = normalize(fallbackVariant.options[index]);

    const radio = Array.from(
      selector.querySelectorAll('input.js-option[type="radio"]')
    ).find((input) => normalize(input.value) === value);

    if (radio) radio.checked = true;

    const select = selector.querySelector('select');
    if (select) select.value = fallbackVariant.options[index];
  });

  const centerInput = centerSelector.querySelector('input.js-option:checked');
  const centerChoice = centerInput?.closest('.bijoux-choice');
  const centerSummary = this.querySelector('.js-center-disclosure-selected');

  if (centerChoice && centerSummary) {
    const carat = centerChoice
      .querySelector('.bijoux-center-choice__carat')
      ?.textContent.replace(/\s+/g, ' ').trim() || '';

    const quality = centerChoice
      .querySelector('.bijoux-center-choice__quality')
      ?.textContent.replace(/\s+/g, ' ').trim() || '';

    centerSummary.textContent = quality ? `${carat} · ${quality}` : carat;
  }

  const metalInput = metalSelector?.querySelector('.js-bijoux-metal-input:checked');
  const metalCurrent = metalSelector?.querySelector('.js-bijoux-metal-current');

  if (metalInput && metalCurrent) {
    metalCurrent.textContent = metalInput.value.trim();
  }
}

    /**
     * Updates the "Add to Cart" button label
     * and disabled state.
     */
    updateAddToCartButton() {
      this.productForm =
        this.section.querySelector('.js-product-form');

      if (!this.productForm) return;

      this.addBtn =
        this.addBtn ||
        this.productForm.querySelector('[name="add"]');

      if (!this.addBtn) return;

      const variantAvailable =
        this.variant &&
        this.variant.available;

      const unavailableStr =
        this.variant
          ? theme.strings.noStock
          : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;

      this.addBtn.textContent =
        variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
    }

updateAvailability() {
  /*
   * On travaille UNIQUEMENT
   * sur le sélecteur Center Diamond.
   */
  const centerSelector = this.querySelector(
    '.bijoux-center-selector'
  );

  if (!centerSelector) return;


  /*
   * On récupère sa position parmi les
   * vraies options Shopify.
   */
  const selectors = Array.from(
    this.optionSelectors
  );

  const centerOptionIndex =
    selectors.indexOf(centerSelector);

  if (centerOptionIndex === -1) return;

  const optionCount =
    this.data.product.options.length;


  /*
   * Sélection actuelle.
   */
  const selectedOptions = this
    .getSelectedOptions()
    .slice(0, optionCount);


  /*
   * Normalisation simple pour éviter
   * les problèmes d'espaces.
   */
  const normalize = (value) => {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  };


  /*
   * Toutes les cartes Center Diamond.
   */
  const centerChoices =
    centerSelector.querySelectorAll(
      '.bijoux-choice'
    );


  centerChoices.forEach((choice) => {

    const input = choice.querySelector(
      'input.js-option[type="radio"]'
    );

    if (!input) return;


    /*
     * On part de la configuration
     * actuellement sélectionnée.
     */
    const optionsToTest = [
      ...selectedOptions
    ];


    /*
     * On remplace uniquement
     * Center Diamond par la valeur
     * de la carte qu'on souhaite tester.
     */
    optionsToTest[
      centerOptionIndex
    ] = normalize(input.value);


    const matchingVariant =
      this.data.product.variants.find(
        (variant) => {

          return variant.options.every(
            (variantOption, index) => {

              return (
                normalize(
                  variantOption
                ) ===
                normalize(
                  optionsToTest[index]
                )
              );

            }
          );

        }
      );


    /*
     * Disponible uniquement si :
     *
     * - la variante existe
     * - Shopify retourne available === true
     */
    const isAvailable =
      Boolean(
        matchingVariant &&
        matchingVariant.available
      );


    /*
     * C'est la seule action visuelle
     * effectuée par le JS.
     */
    choice.classList.toggle(
      'is-unavailable',
      !isAvailable
    );

  });
}

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder =
        this.backorder ||
        this.section.querySelector('.backorder');

      if (!this.backorder) return;

      let hideBackorder = true;

      if (
        this.variant &&
        this.variant.available
      ) {
        const { inventory } =
          this.data.formatted[
            this.variant.id
          ];

        if (
          this.variant.inventory_management &&
          inventory === 'none'
        ) {
          const backorderProdEl =
            this.backorder.querySelector(
              '.backorder__product'
            );

          const prodTitleEl =
            this.section.querySelector(
              '.product-title'
            );

          const variantTitle =
            this.variant.title.includes(
              'Default'
            )
              ? ''
              : ` - ${this.variant.title}`;

          if (
            backorderProdEl &&
            prodTitleEl
          ) {
            backorderProdEl.textContent =
              `${prodTitleEl.textContent}${variantTitle}`;
          }

          hideBackorder = false;
        }
      }

      this.backorder.hidden =
        hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      if (!evt || !evt.target) return;

      const selector =
        evt.target.closest(
          '.option-selector'
        );

      if (!selector) return;

      if (
        selector.dataset.selectorType ===
        'dropdown'
      ) {
        return;
      }

      const colorText =
        selector.querySelector(
          '.js-color-text'
        );

      if (!colorText) return;

      const nextElement =
        evt.target.nextElementSibling;

      if (!nextElement) return;

      const valueElement =
        nextElement.querySelector(
          '.js-value'
        );

      if (!valueElement) return;

      colorText.textContent =
        valueElement.textContent;
    }

    /**
     * Updates custom select data-swatch
     * attributes only for gold selectors.
     */
    updateCustomSelectSwatches() {
      this.optionSelectors.forEach(
        (selector) => {
          if (
            selector.dataset.selectorType !==
            'dropdown'
          ) {
            return;
          }

          const customSelect =
            selector.querySelector(
              '.custom-select'
            );

          if (!customSelect) return;

          const button =
            customSelect.querySelector(
              '.custom-select__btn'
            );

          if (!button) return;

          const labelId =
            button.getAttribute(
              'aria-labelledby'
            ) || '';

          const customSelectId =
            customSelect.getAttribute(
              'id'
            ) || '';

          const isGoldSelector =
            `${labelId} ${customSelectId}`
              .toLowerCase()
              .includes('gold');

          if (!isGoldSelector) {
            button.removeAttribute(
              'data-swatch'
            );

            return;
          }

          const selectedOption =
            customSelect.querySelector(
              '.custom-select__option[aria-selected="true"]'
            );

          let value = '';

          if (selectedOption) {
            value =
              selectedOption.dataset.value ||
              selectedOption.getAttribute(
                'value'
              ) ||
              selectedOption.textContent;
          } else {
            const select =
              selector.querySelector(
                'select'
              );

            const buttonText =
              button.querySelector(
                '.text-start'
              );

            value = select
              ? select.value
              : buttonText
                ? buttonText.textContent
                : button.textContent;
          }

          value = String(value || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();

          if (value) {
            button.setAttribute(
              'data-swatch',
              value
            );
          } else {
            button.removeAttribute(
              'data-swatch'
            );
          }
        }
      );
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (
        !this.variant ||
        !this.variant.featured_media
      ) {
        return;
      }

      if (
        this.section.matches(
          'quick-add-drawer'
        )
      ) {
        this.section.updateMedia(
          this.variant.featured_media.id
        );
      } else {
        this.mediaGallery =
          this.mediaGallery ||
          this.section.querySelector(
            'media-gallery'
          );

        if (!this.mediaGallery) return;

        const variantMedia =
          this.mediaGallery.querySelector(
            `[data-media-id="${this.variant.featured_media.id}"]`
          );

        if (!variantMedia) return;

        this.mediaGallery.setActiveMedia(
          variantMedia,
          true,
          true
        );
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability ||
        this.section.querySelector(
          'pickup-availability'
        );

      if (!this.pickUpAvailability) {
        return;
      }

      if (
        this.variant &&
        this.variant.available
      ) {
        this.pickUpAvailability
          .getAvailability(
            this.variant.id
          );
      } else {
        this.pickUpAvailability
          .removeAttribute(
            'available'
          );

        this.pickUpAvailability.innerHTML =
          '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price =
        this.price ||
        this.section.querySelector(
          '.product-info__price > .price'
        );

      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl =
          this.price.querySelector(
            '.price__current'
          );

        const priceWasEl =
          this.price.querySelector(
            '.price__was'
          );

        const unitPriceEl =
          this.price.querySelector(
            '.unit-price'
          );

        /*
         * Current variant price.
         */
        if (
          priceCurrentEl &&
          this.data.formatted[
            this.variant.id
          ]
        ) {
          priceCurrentEl.innerHTML =
            this.data.formatted[
              this.variant.id
            ].price;
        }

        /*
         * Compare-at price.
         */
        if (priceWasEl) {
          priceWasEl.innerHTML =
            this.data.formatted[
              this.variant.id
            ].compareAtPrice || '';
        }

        /*
         * Unit price.
         */
        if (
          this.variant
            .unit_price_measurement
        ) {
          const valueEl =
            this.price.querySelector(
              '.unit-price__price'
            );

          const unitEl =
            this.price.querySelector(
              '.unit-price__unit'
            );

          const value =
            this.variant
              .unit_price_measurement
              .reference_value;

          const unit =
            this.variant
              .unit_price_measurement
              .reference_unit;

          if (valueEl) {
            valueEl.innerHTML =
              this.data.formatted[
                this.variant.id
              ].unitPrice;
          }

          if (unitEl) {
            unitEl.textContent =
              value === 1
                ? unit
                : `${value} ${unit}`;
          }
        }

        if (unitPriceEl) {
          unitPriceEl.hidden =
            !this.variant
              .unit_price_measurement;
        }

        this.price.classList.toggle(
          'price--on-sale',
          this.variant
            .compare_at_price >
            this.variant.price
        );

        this.price.classList.toggle(
          'price--sold-out',
          !this.variant.available
        );
      }

      const priceDefault =
        this.price.querySelector(
          '.price__default'
        );

      const priceNoVariant =
        this.price.querySelector(
          '.price__no-variant'
        );

      if (priceDefault) {
        priceDefault.hidden =
          !this.variant;
      }

      if (priceNoVariant) {
        priceNoVariant.hidden =
          Boolean(this.variant);
      }
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku =
        this.sku ||
        this.section.querySelector(
          '.product-sku__value'
        );

      if (!this.sku) return;

      const skuAvailable =
        this.variant &&
        this.variant.sku;

      this.sku.textContent =
        skuAvailable
          ? this.variant.sku
          : '';

      if (this.sku.parentNode) {
        this.sku.parentNode.hidden =
          !skuAvailable;
      }
    }

    /**
     * Updates the URL with the selected
     * variant id.
     *
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (
        !evt ||
        evt.type !== 'change' ||
        this.dataset.updateUrl ===
          'false' ||
        !this.variant
      ) {
        return;
      }

      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?variant=${this.variant.id}`
      );
    }

    /**
     * Updates the value of all hidden
     * product [name="id"] inputs.
     */
    updateVariantInput() {
      if (!this.variant) return;

      this.forms =
        this.forms ||
        this.section.querySelectorAll(
          '.js-product-form, .js-instalments-form'
        );

      this.forms.forEach((form) => {
        const input =
          form.querySelector(
            'input[name="id"]'
          );

        if (!input) return;

        input.value =
          this.variant.id;

        /*
         * Product forms initially have
         * their variant input disabled
         * in the theme.
         *
         * Keep original theme behaviour,
         * only update the value/event.
         */
        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });
    }

    /**
     * Gets selected Shopify options
     * from every option-selector.
     *
     * Supports:
     *
     * - native/select-backed custom selects
     * - custom listboxes
     * - radio cards
     *
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach(
        (selector) => {
          if (
            selector.dataset
              .selectorType ===
            'dropdown'
          ) {
            const select =
              selector.querySelector(
                'select'
              );

            if (select) {
              selectedOptions.push(
                select.value.trim()
              );

              return;
            }

            const selectedOption =
              selector.querySelector(
                '[role="option"][aria-selected="true"]'
              );

            if (selectedOption) {
              selectedOptions.push(
                (
                  selectedOption.dataset
                    .value ||
                  selectedOption.textContent ||
                  ''
                ).trim()
              );
            }
          } else {
            const input =
              selector.querySelector(
                'input:checked'
              );

            if (input) {
              selectedOptions.push(
                input.value.trim()
              );
            }
          }
        }
      );

      return selectedOptions;
    }

    /**
     * Gets product JSON data.
     *
     * @returns {?object}
     */
    getProductData() {
      const dataEl =
        this.querySelector(
          '[type="application/json"]'
        );

      if (!dataEl) {
        return {
          product: {
            options: [],
            variants: []
          },
          formatted: {}
        };
      }

      return JSON.parse(
        dataEl.textContent
      );
    }
  }

  customElements.define(
    'variant-picker',
    VariantPicker
  );
}
document.addEventListener('DOMContentLoaded', function () {

  const productSection =
    document.querySelector('.product-main--bijoux');

  if (!productSection) return;

  function updateCenterDisclosure() {

    const disclosure =
      productSection.querySelector(
        '[data-bijoux-center-disclosure]'
      );

    if (!disclosure) return;

    const checked =
      disclosure.querySelector(
        '.bijoux-center-selector .bijoux-choice__input:checked'
      );

    if (!checked) return;

    const choice =
      checked.closest('.bijoux-choice');

    if (!choice) return;

    const carat =
      choice.querySelector(
        '.bijoux-center-choice__carat'
      );

    const quality =
      choice.querySelector(
        '.bijoux-center-choice__quality'
      );

    const output =
      disclosure.querySelector(
        '.js-center-disclosure-selected'
      );

    if (!output) return;

    const caratText =
      carat
        ? carat.textContent.replace(/\s+/g, ' ').trim()
        : '';

    const qualityText =
      quality
        ? quality.textContent.replace(/\s+/g, ' ').trim()
        : '';

    output.textContent =
      qualityText
        ? caratText + ' · ' + qualityText
        : caratText;
  }

  productSection.addEventListener(
    'change',
    function (event) {

      if (
        !event.target.closest(
          '.bijoux-center-selector'
        )
      ) {
        return;
      }

      requestAnimationFrame(
        updateCenterDisclosure
      );
    }
  );

});